import React, { Component, PropTypes } from 'react'
import withCdnUrl from './withCdnUrl'

export class BiColumn__leagues extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <div className="section__body">
            <div className="row">
              <div className="column--half">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-sport.gif`} />
                  <div className="meta">
                    <h3>Sport League</h3>
                    <p>
                      Sport players have the opportunity to compete on the varsity level and earn a state
                      title at a live championship event.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--half">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-club.gif`} />
                  <div className="meta">
                    <h3>Club League</h3>
                    <p>
                      Club players will have full access to the PlayVS platform and enjoy playing with their
                      friends at school, without a live State Championship.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withCdnUrl(BiColumn__leagues)



// WEBPACK FOOTER //
// ./src/common/ui/components/biColumn__leagues.js